<template>
    <div>
        <MobileTitleWithBack v-if="$vuetify.breakpoint.xsOnly">
            Change Password
        </MobileTitleWithBack>
        <v-row
            :class="$vuetify.breakpoint.smAndUp ? 'pl-8' : ''"
        >
            <v-col
                v-if="$vuetify.breakpoint.smAndUp"
                cols="4"
            >
                <ProfileNavigation />
            </v-col>
            <v-col>
                <ChangePassword />
            </v-col>
        </v-row>
    </div>
</template>
<script>
import MobileTitleWithBack from '@/components/MobileTitleWithBack';
import ProfileNavigation from '@/components/ProfileSettings/ProfileNavigation';
import ChangePassword from '@/components/ProfileSettings/ChangePassword';

export default {
    components: {
        MobileTitleWithBack,
        ProfileNavigation,
        ChangePassword,
    },
};
</script>
